import type { ReactNode } from "react";
import { AccordionRoot } from "@design-system/Accordion/Accordion";
import { Separator } from "@design-system/Separator/Separator";
import fieldStyles from "@components/drawers/TaskDrawerFields.module.scss";

const DEFAULT_OPEN_SECTIONS = ["details", "dependencies", "workflow"];

interface TemplateTaskSectionsProps {
    children: ReactNode;
}

export const TemplateTaskSections = ({
    children,
}: TemplateTaskSectionsProps) => (
    <>
        <Separator />
        <AccordionRoot
            multiple
            defaultValue={DEFAULT_OPEN_SECTIONS}
            className={fieldStyles.taskDrawerAccordion}
        >
            {children}
        </AccordionRoot>
    </>
);
